import {
  TYPE_METRIC,
  TYPE_COHORT_METRIC,
  TYPE_DECIMAL,
  TYPE_BRACKET_OPEN,
  TYPE_BRACKET_CLOSE,
  TYPE_OPERATOR,
  OPERATOR_ADD,
  OPERATOR_DIVIDE,
  OPERATOR_MULTIPLY,
  OPERATOR_SUBTRACT,
  BRACKET_OPEN,
  BRACKET_CLOSE,
} from './constants';

export const stringifyFormula = (tokens) => {
  return tokens
    .map(({ value, type }) =>
      type === TYPE_COHORT_METRIC
        ? (value.name || '').replace(/<X>/g, `<${value.dateRange}>`)
        : value
    )
    .join('');
};

export const stringifyFormulaHint = (tokens, metrics, cohortMetrics) => {
  return tokens
    .map(({ value, type }) => {
      if (type === TYPE_METRIC) {
        return (metrics.find(({ id }) => id === value) || {}).name;
      }
      if (type === TYPE_COHORT_METRIC) {
        const { name = '' } =
          cohortMetrics.find(({ id }) => id === value.name) || {};
        return name.replace(/<X>/g, `<${value.dateRange}>`);
      }
      return value;
    })
    .join(' ');
};

export const countOpenBrackets = (tokens) => {
  return tokens.reduce((bracketCount, token) => {
    switch (token.type) {
      case TYPE_BRACKET_OPEN:
        bracketCount++;
        break;
      case TYPE_BRACKET_CLOSE:
        bracketCount--;
        break;
    }
    return bracketCount;
  }, 0);
};

const TTL = 500;

export const parseFormula = (formula = '') => {
  const tokens = [];
  let index = 0;
  let ttl = TTL;

  while (index < formula.length) {
    if (!--ttl) {
      throw new Error(`ttl ${TTL}`);
    }
    let ch = formula.charAt(index);
    if (ch === '{') {
      readClientConst(TYPE_DECIMAL); // example: {EMPTY}
    } else if (isLetter(ch) || isNumber(ch)) {
      readNumberOrMetric();
    } else if (ch === '[') {
      readCohortMetric();
    } else if (isOperator(ch)) {
      tokens.push({
        type: TYPE_OPERATOR,
        value: ch,
      });

      index++;
    } else if (ch === BRACKET_OPEN) {
      tokens.push({
        type: TYPE_BRACKET_OPEN,
        value: ch,
      });
      index++;
    } else if (ch === BRACKET_CLOSE) {
      tokens.push({
        type: TYPE_BRACKET_CLOSE,
        value: ch,
      });
      index++;
    } else {
      throw new Error(`Unexpected next character: ${ch}`);
    }
  }

  return tokens;

  function readCohortMetric() {
    let cohortMetricName = '';
    let cohortMetricDateRange = '';
    let mode = '';

    while (index < formula.length) {
      index++;
      let ch = formula.charAt(index);
      if (ch === '<') {
        break;
      }
      cohortMetricName += ch;
    }

    while (index < formula.length) {
      index++;
      let ch = formula.charAt(index);
      if (ch === '>') {
        break;
      }
      cohortMetricDateRange += ch;
    }

    while (index < formula.length) {
      index++;
      let ch = formula.charAt(index);
      if (ch === ']') {
        break;
      }
      mode += ch;
    }
    index++;

    tokens.push({
      type: TYPE_COHORT_METRIC,
      value: {
        name: `[${cohortMetricName}<X>${mode}]`,
        dateRange: cohortMetricDateRange,
      },
    });
  }

  function readNumberOrMetric() {
    let numberValue = true;
    let value = '';
    while (index < formula.length) {
      let ch = formula.charAt(index);
      const letterChar = isLetter(ch);
      if (letterChar) {
        numberValue = false;
      }

      if (ch === '.' || isNumber(ch) || letterChar) {
        value += ch;
      } else {
        break;
      }
      index++;
    }
    if (numberValue) {
      tokens.push({
        type: TYPE_DECIMAL,
        value: parseFloat(value),
      });
    } else {
      tokens.push({
        type: TYPE_METRIC,
        value: value,
      });
    }
  }

  function readClientConst(type) {
    let constant = '';
    while (index < formula.length) {
      let ch = formula.charAt(index);
      constant += ch;
      index++;
      if (ch === '}') {
        break;
      }
    }

    tokens.push({
      type: type,
      value: constant,
    });
  }
};

function isLetter(ch) {
  return /[a-zA-Z_]/.test(ch);
}

function isNumber(ch) {
  return '0' <= ch && ch <= '9';
}

function isOperator(ch) {
  return [
    OPERATOR_MULTIPLY,
    OPERATOR_DIVIDE,
    OPERATOR_ADD,
    OPERATOR_SUBTRACT,
  ].includes(ch);
}
